<template>
  <div class="content ht-100v pd-0">
    <div ref="mainHeader" class="content-header bd-b pd-0">
      <nav class="navbar navbar-expand-lg wd-100p" style="height: 59px;">
        <a
          class="navbar-brand tx-spacing--2 order-1"
          data-toggle="dropdown"
          role="button"
        >
          Анкетны тохиргоо
        </a>
      </nav>
      <div class="mg-l-auto">
        <button @click="postData()" class="btn btn-success mg-r-10">
          Хадгалах
        </button>
      </div>
    </div>

    <div class="content-body pd-x-0 pd-y-0 overflow-hidden">
      <div class="container-fluid pd-x-0">
        <div class="overflow-auto bg-white" style="height: calc(100vh - 60px)">
          <table
            class="table table-sm table-striped table-bordered"
            v-if="configTask.rdy"
          >
            <thead class="thead-secondary">
              <tr>
                <th scope="col">№</th>
                <th scope="col">Бүрдэл</th>
                <th scope="col">Min</th>
                <th scope="col">Perc</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">1</th>
                <td colspan="2" class="font-weight-bold text-right">
                  Ерөнхий мэдээлэл
                </td>
                <td class="pd-y-0-f">
                  <input
                    v-model="configTask.obj.fl1"
                    type="number"
                    class="form-control form-control-sm"
                  />
                </td>
              </tr>
              <tr v-for="(b, i) in configTask.obj.boxes" :key="i">
                <th scope="row">{{ i + 2 }}</th>
                <td>{{ b.name }}</td>
                <td class="pd-y-0-f">
                  <input
                    v-model="b.minRequiredObjectCount"
                    type="number"
                    class="form-control form-control-sm"
                  />
                </td>
                <td class="pd-y-0-f">
                  <input
                    v-model="b.perc"
                    type="number"
                    class="form-control form-control-sm"
                  />
                </td>
              </tr>
              <tr>
                <td colspan="3" class="font-weight-bold text-right">Нийт:</td>
                <td class="pd-y-0-f">
                  {{
                    configTask.obj.boxes.reduce(
                      (sum, { perc }) => sum + parseInt(perc),
                      0
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tree } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

var LTT = require("list-to-tree");
import { request } from "@/api/all";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

export default {
  components: {},
  data() {
    return {
      configTask: {
        obj: {},
        rdy: false
      },
      mainTask: {
        obj: {},
        rdy: false
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    init() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Config/GetGroupTaskConfig" },
        params: {
          objectTypeId: 138
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.configTask.obj = res.data.configTask;
          this.configTask.rdy = true;
          //console.log('GetGroupTaskConfig=> ', res);
          //this.initAfter(res.data.configTask.id);
        }
      });
    },
    initAfter(id) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "task/getInherited" },
        params: {
          id: id
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.mainTask.obj = res.data.task;
          this.mainTask.rdy = true;
          //console.log('getInherited', res);
        }
      });
    },
    postData() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "Config/PostGroupTaskConfig" },
        data: this.configTask.obj,
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log(res);
          this.init();
        }
      });
    }
  }
};
</script>
